import { MediaTypes } from '../../entitites/common/document-collection.entity';
import { IStaticDocumentEntity } from '../../entitites/common/static-document.entity';

export class StaticDocumentDto {
  readonly type: MediaTypes;
  readonly filename: string;
  readonly mimetype: string;
  readonly path: string;

  constructor(entity: IStaticDocumentEntity, origin?: string) {
    this.type = entity.type as MediaTypes;
    this.filename = entity.name;
    this.mimetype = entity.mimetype;

    this.path = origin ? `${origin}/${entity.path}` : entity.path;
  }
}
